import React from 'react';
import { Outlet } from 'react-router-dom';
import WorkerNavbar from './components/WorkerNavbar';
import WorkerSidebar from './components/WorkerSidebar';

function WorkerLayout() {
  return (
    <div className="min-h-screen overflow-x-hidden bg-[radial-gradient(circle_at_top_left,_rgba(255,122,0,0.12),transparent_20%),radial-gradient(circle_at_bottom_right,_rgba(11,42,74,0.08),transparent_30%),linear-gradient(180deg,#f8fafc_0%,#f1f5f9_100%)] text-slate-900">
      <WorkerNavbar
        role="WORKER"
        mobileMenuItems={[
          { to: '/worker', label: 'Home' },
          { to: '/worker/applications', label: 'Applications' },
          { to: '/worker/hired', label: 'Hired Jobs' },
          { to: '/worker/completed', label: 'Completed Jobs' },
          { to: '/worker/saved', label: 'Saved Jobs' },
          { to: '/worker/messages', label: 'Messages' },
        ]}
      />

      <main className="mx-auto grid max-w-7xl gap-6 px-4 pt-28 pb-24 sm:px-6 lg:px-8 lg:grid-cols-[260px_minmax(0,1fr)_320px]">
        <aside className="hidden lg:block">
          <WorkerSidebar />
        </aside>

        <section className="space-y-6">
          <Outlet />
        </section>

        <aside className="hidden lg:block">
          <div className="rounded-3xl bg-white p-6 shadow-sm">
            <p className="text-sm font-semibold text-navy">Notifications</p>
            <p className="mt-2 text-sm text-slate-600">No new notifications.</p>
          </div>
        </aside>
      </main>
    </div>
  );
}

export default WorkerLayout;

